"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleEventLog = void 0;
class BattleEventLog {
    constructor() {
        this.events = [];
    }
    append(event) {
        this.events.push(event);
    }
    consume() {
        const events = this.events;
        this.events = [];
        return events;
    }
}
exports.BattleEventLog = BattleEventLog;
